import get from 'lodash/fp/get.js';

const isInvisible = (field, visibleFields) => get(field, visibleFields) === false;

export default isInvisible;
